import { render, staticRenderFns } from "./UserNotaryCard.vue?vue&type=template&id=8fc9ecf4&scoped=true"
import script from "./UserNotaryCard.vue?vue&type=script&lang=js"
export * from "./UserNotaryCard.vue?vue&type=script&lang=js"
import style0 from "./UserNotaryCard.vue?vue&type=style&index=0&id=8fc9ecf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc9ecf4",
  null
  
)

export default component.exports